export default "__VITE_ASSET__SE8v5DLx__"